export const NAV_ITEMS = [
  { id: "about", label: "About" },
  { id: "companies", label: "Experience" },
  { id: "projects", label: "Projects" },
];
